export const PublicidadeData = [
  {
    primeiroNome: 'kampyle_userid',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Medallia',
    linkPolitica: 'https://www.medallia.com/privacy-policy/',
  },
  {
    primeiroNome: 'bcookie',
    segundoNome: '.linkedin.com',
    finalidade:
      'Suporta marketing on-line, coletando informações sobre os usuários para promover produtos por meio de parceiros e outras plataformas.',
    validade: 'um ano',
    processadorDados: 'LinkedIn',
    linkPolitica: 'https://www.linkedin.com/legal/privacy-policy',
  },
  {
    primeiroNome: '_gcl_au',
    segundoNome: '.maersk.com',
    finalidade:
      'Suporta a integração de uma plataforma de terceiros no site para fornecer publicidade direcionada.',
    validade: '3 meses',
    processadorDados: 'Google',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: 'utmter',
    segundoNome: '.maersk.com',
    finalidade: '',
    validade: 'um mês',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: 'kampyleSessionPageCounter',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Medallia',
    linkPolitica: 'https://www.medallia.com/privacy-policy/',
  },
  {
    primeiroNome: 'da_sid',
    segundoNome: '.maersk.com',
    finalidade: '',
    validade: '30 minutos',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/cookies',
  },
  {
    primeiroNome: 'da_lid',
    segundoNome: '.decibelinsight.net',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/cookies',
  },
  {
    primeiroNome: 'lidc',
    segundoNome: '.linkedin.com',
    finalidade:
      'Suporta marketing on-line, coletando informações sobre os usuários para promover produtos por meio de parceiros e outras plataformas.',
    validade: 'um dia',
    processadorDados: 'LinkedIn',
    linkPolitica: 'https://www.linkedin.com/legal/privacy-policy',
  },
  {
    primeiroNome: 'utmcam',
    segundoNome: '.maersk.com',
    finalidade: '',
    validade: 'um mês',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: 'utmsrc',
    segundoNome: '.maersk.com',
    finalidade: '',
    validade: 'um mês',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: 'IDE',
    segundoNome: '.doubleclick.net',
    finalidade:
      'Usado para marketing on-line, coletando informações sobre os usuários e suas atividades no site. A informação é usada para direcionar publicidade para o usuário em diferentes canais e dispositivos.',
    validade: 'um ano',
    processadorDados: 'Google Marketing Platform',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: '_fbp',
    segundoNome: '.maersk.com',
    finalidade:
      'Identifica os navegadores com o objetivo de fornecer serviços de publicidade e análise do site.',
    validade: '3 meses',
    processadorDados: 'Facebook',
    linkPolitica: 'https://www.facebook.com/privacy/explanation',
  },
  {
    primeiroNome: 'li_gc',
    segundoNome: '.linkedin.com',
    finalidade:
      'Suporta marketing on-line, coletando informações sobre os usuários para promover produtos por meio de parceiros e outras plataformas.',
    validade: '6 meses',
    processadorDados: 'LinkedIn',
    linkPolitica: 'https://www.linkedin.com/legal/privacy-policy',
  },
  {
    primeiroNome: 'utmcon',
    segundoNome: '.maersk.com',
    finalidade: '',
    validade: 'um mês',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: 'utmmed',
    segundoNome: '.maersk.com',
    finalidade: '',
    validade: 'um mês',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: 'da_sid',
    segundoNome: '.decibelinsight.net',
    finalidade: '',
    validade: '17 minutos',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/cookies',
  },
  {
    primeiroNome: 'TDID',
    segundoNome: '.adsrvr.org',
    finalidade:
      'Suporta a integração de uma plataforma de terceiros no site para fornecer publicidade direcionada.',
    validade: 'um ano',
    processadorDados: 'The Trade Desk',
    linkPolitica: 'https://www.thetradedesk.com/general/privacy',
  },
  {
    primeiroNome: 'mdLogger',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Medallia',
    linkPolitica: 'https://www.medallia.com/privacy-policy/',
  },
  {
    primeiroNome: 'kampyleUserSession',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Medallia',
    linkPolitica: 'https://www.medallia.com/privacy-policy/',
  },
  {
    primeiroNome: 'kampyleUserSessionsCount',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Medallia',
    linkPolitica: 'https://www.medallia.com/privacy-policy/',
  },
  {
    primeiroNome: 'TDCPM',
    segundoNome: '.adsrvr.org',
    finalidade:
      'Suporta a integração de uma plataforma de terceiros no site para fornecer publicidade direcionada.',
    validade: 'um ano',
    processadorDados: 'The Trade Desk',
    linkPolitica: 'https://www.thetradedesk.com/general/privacy',
  },
  {
    primeiroNome: '_gcl_au',
    segundoNome: '.maersk.com.cn',
    finalidade:
      'Suporta a integração de uma plataforma de terceiros no site para fornecer publicidade direcionada.',
    validade: '3 meses',
    processadorDados: 'Google',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: 'test_cookie',
    segundoNome: '.doubleclick.net',
    finalidade:
      'Usado para marketing on-line, coletando informações sobre os usuários e suas atividades no site. A informação é usada para direcionar publicidade para o usuário em diferentes canais e dispositivos.',
    validade: '15 minutos',
    processadorDados: 'Google Marketing Platform',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: 'kampyleUserSessionsCount',
    segundoNome: 'beta.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Medallia',
    linkPolitica: 'https://www.medallia.com/privacy-policy/',
  },
  {
    primeiroNome: 'kampyle_userid',
    segundoNome: 'beta.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Medallia',
    linkPolitica: 'https://www.medallia.com/privacy-policy/',
  },
  {
    primeiroNome: 'mdLogger',
    segundoNome: 'beta.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Medallia',
    linkPolitica: 'https://www.medallia.com/privacy-policy/',
  },
  {
    primeiroNome: 'kampyleSessionPageCounter',
    segundoNome: 'beta.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Medallia',
    linkPolitica: 'https://www.medallia.com/privacy-policy/',
  },
  {
    primeiroNome: 'kampyleUserSession',
    segundoNome: 'beta.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Medallia',
    linkPolitica: 'https://www.medallia.com/privacy-policy/',
  },
  {
    primeiroNome: '_fbp',
    segundoNome: '.maersk.com.cn',
    finalidade:
      'Identifica os navegadores com o objetivo de fornecer serviços de publicidade e análise do site.',
    validade: '3 meses',
    processadorDados: 'Facebook',
    linkPolitica: 'https://www.facebook.com/privacy/explanation',
  },
]
